import { Store } from 'vuex';
import api from '@/common/utils/api';

export default class ApiPlugin {
  readonly store: Store<any>;

  constructor({ store }) {
    this.store = store;
    this.store.$api = api;
  }

  static install(): (store) => ApiPlugin {
    return store => new ApiPlugin({ store });
  }
}
